<exam-asset-tree-view [readOnly]="false">
  <router-outlet />
</exam-asset-tree-view>
